// extracted by mini-css-extract-plugin
export default {"Mackerel":"#D2D6D9","wrapper":"List_wrapper__hZY3x","item":"List_item__V9xZO"};